import React from 'react';
import {observer} from "mobx-react";
import {ShowableProductCard} from "ReactApp/Ddd/Aggregates/ShowableProductCard";

type SizeSelectorV1Props = {
    productCard: ShowableProductCard
}
const SizeSelectorV1 = observer(({ productCard }: SizeSelectorV1Props) => {

    function handleSelectChange(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        productCard.switchRealModifier(
            Number(event.currentTarget.attributes['data-modifier-id'].nodeValue)
        );
    }

    let {currentProductConfig} = productCard;
    const { realModifiers } = productCard;

    if (!currentProductConfig) {
        return <div>Загрузка...</div>;
    }

    if (!productCard || !productCard.realModifiers)
        return <></>;

    const uniqueKey = currentProductConfig.getUniqueId();
    let activeLabel = '';
    for (let modifier of realModifiers) {
        if (modifier.isActive) {
            activeLabel = modifier.label;
            break;
        }
    }

    if (!activeLabel && realModifiers.length) {
        activeLabel = realModifiers[0].label;
    }

    const collection = realModifiers.map(modifier => {
        return (
            <div key={modifier.realModifierId}
                 className={`size-selector-v1__dropdown-item ${
                     modifier.isActive
                         ? 'size-selector-v1__dropdown-item-active'
                         : ''
                 }`}>
                <a onClick={handleSelectChange}
                   data-modifier-id={modifier.realModifierId ?? undefined}
                   href={modifier.url}
                >
                    {modifier.label}
                </a>
            </div>
        );
    });


    return (
        <div key={uniqueKey}>
            <span className="size-selector-v1__highlight">{activeLabel}</span>
            <div className="size-selector-v1__dropdown thin-scrollbar" style={{maxHeight: '51rem'}}>
                {collection ?? <></>}
            </div>
            <svg className="icon-v1" width="14" height="14">
                <use xlinkHref="/build/sprite.svg#select-corner-icon">
                </use>
            </svg>
        </div>
    );
})

export {SizeSelectorV1};